import React, { useEffect, useState } from "react";
import LocationHeading from "../../../shared/LocationHeading";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Table } from "react-bootstrap";
import viewIcon from "../../../assets/Images/action_view.svg";
import noData from "../../../assets/Images/NoData.svg";
import Loading from "../../../shared/Loading";
import {
  useUserContext,
  setCurrentPage,
} from "../../../components/context/UserContext";
import client from "../../../services/Client";

const LockedPlots = () => {
  const [lockedPlots, setLockedPlots] = useState([]);
  const [total, setTotal] = useState(0);
  const [orderId, setOrderId] = useState("");
  const [debouncedOrderId, setDebouncedOrderId] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [perPage] = useState(10);

  const { state, dispatch } = useUserContext();
  const currentPage = state.currentPage;

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedOrderId(orderId);
    }, 800);
    return () => clearTimeout(timer);
  }, [orderId]);

  const fetchLockedPlots = async () => {
    setIsLoading(true);

    const queryParams = [];
    if (debouncedOrderId) {
      queryParams.push(`orderNumber=${encodeURIComponent(debouncedOrderId)}`);
      dispatch(setCurrentPage(1));
    }
    queryParams.push(`page=${currentPage}`);
    queryParams.push(`perPage=${perPage}`);

    const queryString = queryParams.join("&");

    try {
      const response = await client.get(
        `admin/all-locked-plots?${queryString}`,
        {
          headers: {
            Authorization: `Bearer ${state.token}`,
            "ngrok-skip-browser-warning": "69420",
          },
        }
      );
      const data = response.data?.data || {};
      const list = (data?.orders || []).map((order) => ({
        id: order?.id,
        orderId: order?.orderNumber,
        name: order?.user?.firstName + " " + order?.user?.lastName || "-",
        email: order?.user?.email || "-",
        phone: order?.user?.phoneNumber?.number
          ? `${order?.user?.phoneNumber?.dialCode} ${order?.user?.phoneNumber?.number}`
          : "-",
        plotNumbers: order?.plotNumber || "-",
        price: order?.price || "-",
        paymentType:
          order?.paymentType === "bankTransfer"
            ? "Bank Transfer"
            : order?.paymentType === "funeralFinance"
            ? "Funeral Safe Finance"
            : "-",

        requestedOnDate: new Date(order?.createdAt).toLocaleDateString() || "-",
        paymentStatus: order?.paymentStatus || "-",
      }));

      setLockedPlots(list);
      setTotal(data.total || 0);
    } catch (error) {
      console.error("Error fetching locked plots:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const page = parseInt(queryParams.get("page"), 10) || 1;
    if (page !== currentPage) {
      dispatch(setCurrentPage(page));
    }
    fetchLockedPlots();
  }, [debouncedOrderId, location.search, currentPage]);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= Math.ceil(total / perPage)) {
      dispatch(setCurrentPage(newPage));
      navigate(`/lockedPlots?page=${newPage}`);
    }
  };

  const handleClearSearch = () => {
    setOrderId("");
    fetchLockedPlots();
  };

  if (isLoading) {
    return (
      <div className="overlay">
        <Loading />
      </div>
    );
  }

  return (
    <>
      <div className="location_list">
        <LocationHeading title={"Locked Plots"} />
        <div className="loaction-list-main">
          <div className="loaction-list-head">
            <div className="search-bar">
              <input
                type="text"
                placeholder="Search by order id"
                value={orderId}
                onChange={(e) => setOrderId(e.target.value)}
              />
              {orderId && (
                <i
                  className="fa fa-times-circle clear-icon"
                  aria-hidden="true"
                  onClick={handleClearSearch}
                  style={{ cursor: "pointer" }}
                ></i>
              )}
              <i className="fa fa-search" aria-hidden="true"></i>
            </div>
          </div>

          <div>
            <Table size="lg" className="location_list-table">
              <thead>
                <tr>
                  <th>Order Id</th>
                  <th>Name</th>
                  <th>Email Address</th>
                  <th>Phone Number</th>
                  <th>Plot Number</th>
                  <th>Price</th>
                  <th>Payment Type</th>
                  <th>Requested On</th>
                  <th>Payment Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {lockedPlots && lockedPlots?.length > 0 ? (
                  lockedPlots.map((plot) => (
                    <tr key={plot?.id}>
                      <td>{plot?.orderId}</td>
                      <td>{plot?.name}</td>
                      <td>{plot?.email}</td>
                      <td>{plot?.phone}</td>
                      <td>{plot?.plotNumbers}</td>
                      <td>£{plot?.price?.toFixed(2)}</td>
                      <td>{plot?.paymentType}</td>
                      <td>{plot?.requestedOnDate} </td>
                      <td>
                        <button
                          className={`status_button ${
                            plot.paymentStatus === "Pending"
                              ? "draft"
                              : plot.paymentStatus === "Paid"
                              ? "available"
                              : "sold"
                          }`}
                        >
                          {plot?.paymentStatus}
                        </button>
                      </td>
                      <td>
                        <Link
                          className="action-view"
                          to={`/lockedPlots/LockedPlotDetails/${plot?.orderId}`}
                        >
                          <img src={viewIcon} alt="icon" />
                        </Link>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="10" className="text-center no_data-image">
                      <img src={noData} alt="No Data" width="100%" />
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>

            {/* Pagination */}
            <div className="next-previous-slide">
              <div className="slides-heading">
                <span>
                  Showing {(currentPage - 1) * perPage + 1} to{" "}
                  {Math.min(currentPage * perPage, total)} out of {total}
                </span>
              </div>
              <div className="slides-button">
                <ul className="d-flex justify-center align-items-center">
                  <li>
                    <button
                      disabled={currentPage === 1}
                      onClick={() => handlePageChange(currentPage - 1)}
                    >
                      <i
                        className="fa fa-angle-left"
                        aria-hidden="true"
                        style={{ cursor: "pointer", color: "#333" }}
                      ></i>
                    </button>
                  </li>
                  <li className="d-flex justify-center align-items-center">
                    {Array.from({ length: Math.ceil(total / perPage) }).map(
                      (_, index) => {
                        // Add logic to display ellipsis (...) if there are many pages
                        if (
                          index < 2 ||
                          index > Math.ceil(total / perPage) - 3 ||
                          (index >= currentPage - 2 && index <= currentPage + 1)
                        ) {
                          return (
                            <button
                              key={index + 1}
                              onClick={() => handlePageChange(index + 1)}
                              className={
                                currentPage === index + 1 ? "active" : ""
                              }
                            >
                              {index + 1}
                            </button>
                          );
                        } else if (
                          index === 2 ||
                          index === Math.ceil(total / perPage) - 3
                        ) {
                          return <span key={index}>...</span>;
                        }
                        return null;
                      }
                    )}
                  </li>
                  <li>
                    <button
                      disabled={currentPage === Math.ceil(total / perPage)}
                      onClick={() => handlePageChange(currentPage + 1)}
                    >
                      <i className="fa fa-angle-right" aria-hidden="true"></i>
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LockedPlots;
